import { spacing } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-layout-alignment-block";
const center = objectWithClassName({
  display: "flex",
  justifyContent: "center",
  className: [
    `${classNamePrefix}-center`,
    /** @deprecated Use 'umd-layout-alignment-block-center' instead */
    "umd-layout-element-alignment-center"
  ]
});
const stacked = objectWithClassName({
  display: "flex",
  flexDirection: "column",
  "& > *": {
    marginTop: spacing.sm,
    "&:first-child": {
      marginTop: "0"
    }
  },
  className: [
    `${classNamePrefix}-stacked`,
    /** @deprecated Use 'umd-layout-alignment-block-stacked' instead */
    "umd-media-with-caption"
  ]
});
export {
  center,
  stacked
};
//# sourceMappingURL=block.js.map
